import { create } from 'zustand';

import {
  createToolCallStatusSlice,
  type ToolCallStatusEntry,
  type ToolCallStatusSlice,
} from './slices/createToolCallStatusSlice';

export type ToolCallStatusState = ToolCallStatusSlice;

const EMPTY_STATUSES: ToolCallStatusEntry[] = [];

export const useToolCallStatusStore = create<ToolCallStatusState>()((...args) => ({
  ...createToolCallStatusSlice()(...args),
}));

/** Returns tool call statuses for a given thread. */
export const useToolCallStatusForThread = (threadId: string | null) => {
  return useToolCallStatusStore((state) => (threadId ? (state.byThread[threadId] ?? EMPTY_STATUSES) : EMPTY_STATUSES));
};
